<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <div class="prev"></div>
  <h2>Device Activities</h2>
  <div class="next"></div>
</nav>

<div class="container container-inner">
  <div class="row">
    <div
      class="col-12"
      *ngIf="syncedActivities && syncedActivities.length == 0"
    >
      <p>There are no activities to sync</p>
    </div>

    <div class="col-12" *ngIf="syncedActivities && syncedActivities.length > 0">
      <h4 class="text-center mt-4 mb-2">Activities captured by your device</h4>
      <div class="card bg-light">
        <div class="card-body">
          <table class="entries-table">
            <thead>
              <tr>
                <th></th>
                <th>Activity</th>
                <th>Duration</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <!-- assume garmin for now -->
              <ng-container *ngFor="let activity of syncedActivities">
                <tr>
                  <td>
                    <span class="et-cell text-dark fw-bold"
                      ><span class="et-total">
                        {{
                          activity.activity_data.startTimeInSeconds * 1000
                            | customDate : "DD"
                        }}</span
                      ><span class="et-label">{{
                        activity.activity_data.startTimeInSeconds * 1000
                          | customDate : "MMM"
                      }}</span>
                    </span>
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total"></span
                      ><span class="et-label">{{
                        activity.activity_data.activityType
                      }}</span></span
                    >
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{
                        activity.activity_data.durationInSeconds / 60 | number
                      }}</span
                      ><span class="et-label">mins</span></span
                    >
                  </td>

                  <td width="40">
                    <span class="et-cell"
                      ><a class="btn btn-sm" (click)="onDelete(activity)">
                        <span class="icon-wrap text-dark"
                          ><fa-icon [icon]="['fal', 'trash']"></fa-icon
                        ></span>
                        Delete</a
                      ></span
                    >
                  </td>

                  <td width="40">
                    <span class="et-cell"
                      ><a
                        class="btn btn-sm"
                        [routerLink]="[
                          '/activity',
                          'fit',
                          'add-entry',
                          activity.user_synced_activity_id
                        ]"
                      >
                        <span class="icon-wrap duo-primary-dark"
                          ><fa-icon
                            [icon]="['fad', 'circle-chevron-right']"
                          ></fa-icon
                        ></span>
                        ADD</a
                      ></span
                    >
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
